export * from './ogive-chart.component';
export * from './ogive-chart.model';
export * from './ogive-explain.component';
